const currencySymbols = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  ZAR: 'R',
};

export const currencySymbol = (currency = 'ZAR') => currencySymbols[currency] || currency || 'R';

export const parsePrice = (price) => {
  const numericPrice = Number(String(price || '').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(numericPrice) ? numericPrice : 0;
};

const decimalPlacesForPrice = (price) => {
  const decimalMatch = String(price || '').match(/[.,](\d+)/);
  return decimalMatch ? decimalMatch[1].length : 0;
};

const formatGroupedAmount = (amount, decimalPlaces = 0) => (
  amount.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).replace(/,/g, ' ')
);

export const formatPrice = (currency, price, decimalSource = price) => {
  const amount = parsePrice(price);
  return `${currencySymbol(currency)}${formatGroupedAmount(amount, decimalPlacesForPrice(decimalSource))}`;
};

export const calculateDiscountedPrice = (price, discountType, discountValue) => {
  const originalPrice = parsePrice(price);
  const discount = Math.max(parsePrice(discountValue), 0);

  if (!originalPrice || !discount) return originalPrice;

  if (discountType === 'amount') {
    return Math.max(originalPrice - discount, 0);
  }

  return Math.max(originalPrice - (originalPrice * Math.min(discount, 100) / 100), 0);
};

export const getEffectivePrice = (item = {}) => {
  const discountValue = item.discountValue || '';
  if (discountValue !== '') {
    return calculateDiscountedPrice(item.price, item.discountType || 'percentage', discountValue);
  }

  if (item.reducedPrice) return parsePrice(item.reducedPrice);
  return parsePrice(item.price);
};

export const hasDiscountedPrice = (item = {}) => (
  parsePrice(item.price) > 0 && getEffectivePrice(item) < parsePrice(item.price)
);
